export default function toTitleCase(text: string) {
  return text.replace(/\w\S*/g, function (string: string) {
    return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase()
  })
}
